import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { LabelPaneComponent } from 'projects/app-default/src/app/ui/display/label-pane/label-pane.component';
import { LocalProduct } from '../../../model/product/product.decorator';
import { ProductViewLayoutComponent } from '../view-layout/product-view-layout.component';
@Component({
    selector: 'product-view-delivery-note',
    templateUrl: './product-view-delivery-note.html',
    standalone: true,
    imports: [LabelPaneComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewDeliveryNoteComponent extends UiComponent {
    @Input()
    product?: LocalProduct<IProductDataV3>;
    readonly productViewLayout = inject(ProductViewLayoutComponent);
}
